import { useIndustry } from '@/app/providers/industry-context.js';
import FooterDefault from './Footer.default.jsx';
import FooterDemo from './Footer.demo.jsx';
import FooterFish from './Footer.fish.jsx';
import FooterGrocery from './Footer.grocery.jsx';
import FooterMeat from './Footer.meat.jsx';
import FooterRestaurant from './Footer.restaurant.jsx';
import FooterPet from './Footer.pet.jsx';
import FooterCoffee from './Footer.coffee.jsx';

const registry = {
  default: FooterDefault,
  demo: FooterDemo,
  fish: FooterFish,
  grocery: FooterGrocery,
  meat: FooterMeat,
  restaurant: FooterRestaurant,
  pet: FooterPet,
  coffee: FooterCoffee,
};

export default function Footer(props) {
  const { key } = useIndustry();
  const Component = registry[key] ?? registry.default;
  return <Component {...props} />;
}
